import React, { useEffect, useMemo, useState } from 'react';
import { Button, Checkbox, Col, Modal, Row, Select, Space, Spin, Table, Tabs, Tooltip, message } from 'antd';
import { connect, useDispatch, useSelector} from 'react-redux';
import { ze } from 'utils/zhEn';
import RestHelper from 'utils/RestHelper';
import { getIssueDetailUrlPrefix } from 'utils/helper';
import { Link } from 'react-router-dom';
import reportEvent, { EVENT_ACTIONS, getExceptionTypeReportName, getPageTitle } from 'utils/reportEvent';
import _style from 'components/exception/BaseProblemPage/IssueItem/style.scss';
import IssueIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_list_issueid_icon.svg';
import ExceptionsIcon from 'svg/v2/newcs_dashboard_overview_dailytopissue_list_yichangname_icon.svg';
import { useTranslation } from 'react-i18next';
import { CrashUtil } from 'utils/api/crash';
import moment from 'moment';
import { TimeUtil } from 'utils/time-util';

const SimilarIssues = ({
  reduxState,
  appId,
  pid,
  issueId,
  exceptionCategory,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const issueDetailUrlPrefix = getIssueDetailUrlPrefix(exceptionCategory);

  useEffect(() => {
    fetchSimilarIssues();
  }, []);

  async function fetchSimilarIssues() {
    setLoading(true);
    const rsp = await RestHelper.post('/redir/api/issue/querySimilarIssues', {
      appId,
      issueId,
    });
    const items = rsp.json.data.items.map(x => {
      const { similarity, issueDetail } = x;
      const similarityPercentText = `${(similarity * 100).toFixed(2)}%`;
      let lastReportTimeText = '';
      let totalReportsText = '';
      let totalDevicesText = '';
      if (issueDetail) {
        const lastReportTime = moment(TimeUtil.fixChaosMillis(issueDetail.latestUploadTimestamp)).format('YYYY-MM-DD HH:mm:ss');
        lastReportTimeText = <div>
          <div>{`${lastReportTime.split(' ')[0]}`}</div>
          <div>{`${lastReportTime.split(' ')[1]}`}</div>
        </div>;
        totalReportsText = issueDetail.count;
        totalDevicesText = issueDetail.imeiCount;
      }

      return {
        ...x,
        similarityPercentText,
        lastReportTimeText,
        totalReportsText,
        totalDevicesText,
      };
    });
    items.sort((a, b) => b.similarity - a.similarity);
    setTableData(items);
    setLoading(false);
  }

  function renderIssueDetail(issueDetail) {
    const {
      issueId,
      exceptionName,
      exceptionMessage,
      keyStack,
      lastMatchedReport,
    } = issueDetail;
    const hasLastMatchedReport = (lastMatchedReport || {}).exists || false;
    const lastMatchedReportRefinedCrashMap = CrashUtil.makeRefinedCrashMap((lastMatchedReport || {}).crashMap);
    const {
      expMessage: lastReportExpMessage,
      firstDefinitiveStackLine,
    } = lastMatchedReportRefinedCrashMap;
    const displayExpMessage = hasLastMatchedReport ? lastReportExpMessage : exceptionMessage;
    const displayKeyStack = hasLastMatchedReport ? firstDefinitiveStackLine : keyStack;

    const isOpenIssueInNewTab = true;

    return <div style={{ flexGrow: '1' }}>
      <Row gutter='15'>
        <Col flex='none'>
          <div style={{ display: 'flex' }}>
            <Link
              to={`/${issueDetailUrlPrefix}/${appId}/${issueId}?pid=${pid}`}
              {...(isOpenIssueInNewTab && { target: '_blank' })}
              rel="noopener noreferrer"
              onClick={() => {
                reportEvent({
                  action: EVENT_ACTIONS.CLICK,
                  tp1: `${getExceptionTypeReportName(exceptionType)}点击链接`,
                  tp6: `${window.location.origin}/${issueDetailUrlPrefix}/${appId}/${issueId}?pid=${pid}`,
                })
              }}
            >
              <Space className={_style.error_title} size={4}>
                {<span style={{ marginTop: -2 }}>{<IssueIcon />}</span>}
                {
                  <Tooltip arrow={true}
                           placement="top"
                           title={(<div>{ issueId }</div>)}
                  >
                    {<div className={_style.error_title_id}>{issueId}</div>}
                  </Tooltip>
                }
                {<span style={{ margin: '-2px 0 0 1px' }}>{<ExceptionsIcon />}</span>}
                {
                  <Tooltip arrow={true}
                           placement="top"
                           title={(<div>{ exceptionName }</div>)}
                  >
                    {<div className={_style.error_title_type}>{exceptionName}</div>}
                  </Tooltip>
                }
              </Space>
            </Link>
          </div>
        </Col>
      </Row>

      <div className={_style.error_info}>
        { !hasLastMatchedReport && <div style={{ fontSize: '12px', color: '#AAA', marginRight: '4px' }}>{ ze('未找到最近一条上报，将显示首次上报信息。', 'Last report not found, showing first report instead.') }</div> }
        { displayExpMessage && <div><span style={{ fontSize: '12px', color: '#AAA', marginRight: '4px' }}>{ t('issueCrashFilterKey.crashExpMessage') }</span><span>{ displayExpMessage }</span></div> }
        <div className={_style.less_info}>
          <p className={_style.key_stack}>
            <Tooltip title={ze('用于问题分类的第一行堆栈。', 'The top of the stack trace used for issue grouping.')}>
              <span style={{ fontSize: '12px', color: '#AAA', marginRight: '4px' }}>{t('REPORTDETAIL.首行关键堆栈')}</span>
              <span>{displayKeyStack || ''}</span>
            </Tooltip>
          </p>
        </div>
      </div>

      {/*
        <div>
          <TagList
            tags={issue.get('tagInfoList')}
            {...{
              dispatch, addTag, delTag, issueId, path, demoApp, issueVersions, ftName, appId, pid,
              firstUploadTimestamp, latestUploadTimestamp, mergeIssueType: esMap?.mergeIssueType,
              firstCrashVersion: issueStartingVersion ? firstCrashVersion : null, // 搜索条件带首次版本的时候tag里才显示
            }} />
        </div>
      */}
    </div>
  }

  const columns = [/*{
    dataIndex: 'issueId',
    title: ze('问题ID', 'Issue ID'),
    render: (value) => {
      return <Link
        to={`/${issueDetailUrlPrefix}/${appId}/${value}?pid=${pid}`}
        target='_blank'
        rel="noopener noreferrer"
      >{ value }</Link>;
    },
  },*/ {
    dataIndex: 'issueDetail',
    title: ze('问题', 'Issue'),
    render: (value, record) => {
      const { issueId, issueDetail } = record;
      if (issueDetail) {
        return renderIssueDetail(issueDetail);
      } else {
        return `${issueId} (${ze('详情不存在', 'Issue Detail Not Found')})`;
      }
    },
  }, {
    dataIndex: 'similarityPercentText',
    title: ze('相似度', 'Similarity'),
    align: 'right',
  }, {
    dataIndex: 'lastReportTimeText',
    title: ze('最近上报', 'Recent'),
    align: 'right',
  }, {
    dataIndex: 'totalReportsText',
    title: ze('累计发生次数', 'Total Reports'),
    align: 'right',
  }, {
    dataIndex: 'totalDevicesText',
    title: ze('累计影响设备数', 'Total Devices'),
    align: 'right',
  }];

  const dom = <Spin spinning={loading}>
    <Table
      style={{ width: '100%' }}
      size={'small'}
      columns={columns}
      dataSource={tableData}
    />
  </Spin>;

  return dom;
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(SimilarIssues);
